import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import {Link, withRouter} from "react-router-dom";
import React, { Component } from 'react';
import Menu from "../components/Menu/Menu";
import betaLogo from "../images/alumsumlogotm.png";
import "./spinwheel.scss";

class Spinwheel extends Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state = {
            loading: false,
            error: null,
            extUserId: null,
            token: null,
            refreshToken: null,
            csrfToken: cookies.get('XSRF-TOKEN')
        };
    }

    async componentDidMount() {
        await fetch('/alumsum/spinwheelInfo', {credentials: 'include'})
            .then(async response => {
                const data = await response.json();
                console.log("user infor returned: ", data);
                this.setState({extUserId: data.extUserId})
                this.setState({token: data.userToken})
                this.setState({refreshToken: data.userRefreshToken})

                // const Spinwheel = window.Spinwheel;
                /* init Spinwheel */
                const Spinwheel = window.Spinwheel;
            })
            .then(data => this.setState({isLoaded: true})
            );
        console.log("user informtaion passed: ", this.state);
        console.log("authentication ", process.env.REACT_APP_PROD_SPINWHEEL_KEY);
        const Spinwheel = window.Spinwheel;
        const handler = Spinwheel.create({
            containerId: "dropin-container",
            env: "production",
            dropinConfig: {
                module: "loan-servicers-login",
                token: this.state.token,
                header: 0
            }
        });
        handler.open();
    }

    render() {
            return (
                <div className="loanContainer">
                    <div className="app-content display-flex h-100">
                        <Menu data={this.state}></Menu>
                        <div id="main-loan-content" className="wd-100">
                            <Link to="/alumsum/dashboard"><img src={betaLogo} alt="logo" className="responsiveLogo"/></Link>
                            <div className="stepperline">
                                <br>

                                </br>
                                <div className="onboardloansrectangle">
                                <div style={{ height: "100%", width: "100%" }} id="dropin-container"></div>
                                    <div className="We-need-your-loan-in">
                                        {/* <div className="loanlogo">
                                            <div className="outerLogo">
                                            </div>
                                            <div className="ovalRow">
                                            </div>
                                            <div className="finicity-logo">
                                            </div>
                                            <div className="ovalRow">
                                            </div>
                                            <div className="outerLogo">
                                            </div>
                                        </div>
                                        <div className="usesPlaid">
                                        </div> */}
                                        {/* <div className="addLoans">
                                            <div className="loanButtonRow">
                                                <div style={{ height: "100%", width: "100%" }} id="dropin-container"></div>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                // <div className="loansContainer">
                // <div style={{height: "auto", width: "auto"}} id="dropin-container"></div>
                // </div>

            )
        }
}
export default withCookies(withRouter(Spinwheel));